import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCorePolicyConflictsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-policy-conflicts',
	path: '/jira/core/projects/:projectKey/settings/policies/conflicts/:entityType',
	exact: true,
	query: ['sourceEntityId?'],
};
